export default function (totalCharge, quantity, transactionId) {
  if (typeof TTDUniversalPixelApi === "function") {
    var universalPixelApi = new TTDUniversalPixelApi();
    universalPixelApi.init(
      "aszns79",
      ["e187lw7"],
      "https://insight.adsrvr.org/track/up",
      {
        td1: transactionId,
        td2: quantity,
        v: totalCharge,
      },
    );
  }

  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    content_ids: [transactionId],
    content_type: "product",
  }, {
    eventID: transactionId,
  });
}
